<template>
  <sidebar-menu
    class="mysidebar"
    :menu="menu"
    @toggle-collapse="onToggleCollapse"
  >
    <span slot="toggle-icon">
      <i class="fas fa-arrows-alt-h"></i>
    </span>
  </sidebar-menu>
</template>
<script>
import http from "@/http";
import authentication from "../util/authentication";

export default {
  name: "Sidebar",
  data() {
    return {
      isAdmin: true,
      menu: [],
      appWrapper: Object,
      pending: {
        user: 0,
        post: 0
      }
    };
  },
  mounted() {
    this.isAdmin = authentication.isAdmin();
    this.appWrapper = document.getElementById("app");
    this.appWrapper.style.paddingLeft = "240px";
    this.menu = [{
        header: true,
        title: "Pedline",
        hiddenOnCollapse: true
      },
      {
        href: "/contact",
        title: "Contatos",
        icon: "fa fa-envelope-open",
        hidden: !this.isAdmin
      },
      {
        href: "/usuario",
        title: "Usuários",
        icon: "fa fa-user",
        hidden: !this.isAdmin
      },
      {
        href: "/post",
        title: "Posts",
        icon: "fa fa-newspaper"
      },
      {
        href: "/newsletter",
        title: "Newsletter",
        icon: "fa fa-newspaper",
        hidden: !this.isAdmin
      }
    ];
  },
  created() {
    if(authentication.isAdmin()) {
      http.get("Administrator/Pending", authentication.getHeaders())
        .then(response => {
          this.pending = response.data;
        });
    }
    
  },
  methods: {
    onToggleCollapse(collapsed) {
      if (!collapsed) {
        this.appWrapper.style.paddingLeft = "240px";
      } else {
        this.appWrapper.style.paddingLeft = "50px";
      }
    }
  }
};
</script>

<style scoped>
.mysidebar {
  max-width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue